import { connect } from 'react-redux';
import { Map } from 'immutable';

import decorate from '../../utils/decorate';

import * as sendMessage from '../../modules/trader-chat/actions/send-message';
import * as getChat from '../../modules/trader-chat/actions/get-chat';
import * as assignChat from '../../modules/trader-chat/actions/assign-chat';
import * as unassignChat from '../../modules/trader-chat/actions/unassign-chat';
import * as endChat from '../../modules/trader-chat/actions/end-chat';
import * as sendTyping from '../../modules/trader-chat/actions/send-typing';
import * as deleteMessage from '../../modules/trader-chat/actions/delete-message';

import injectPermissions from '../../utils/permissionsInject';

import TraderChat from './TraderChat.jsx';

function mapStateToProps(state, props) {
    let chat = state.chats.get('items').get(props.chatId, Map());
    let isError = chat.get('state') === 'ERROR';
    let isUserTyping = chat.get('isUserTyping');

    return {
        accountId: state.user.getIn([ 'data', 'id' ]),
        assignee: chat.get('assignee'),
        messages: chat.get('messages'),
        errors: isError ? chat.get('errors') : void 0,
        isUserTyping
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onSendMessageRequest: (chatId, message) => dispatch(sendMessage.request(chatId, message)),
        onGetChatRequest: (chatId) => dispatch(getChat.request(chatId)),
        onAssignChatRequest: (chatId) => dispatch(assignChat.request(chatId)),
        onUnassignChatRequest: (chatId) => dispatch(unassignChat.request(chatId)),
        onEndChatRequest: (chatId) => dispatch(endChat.request(chatId)),
        onTyping: (chatId) => dispatch(sendTyping.start(chatId)),
        onStopTyping: (chatId) => dispatch(sendTyping.stop(chatId)),
        onDeleteMessageRequest: (chatId, messageId) => dispatch(deleteMessage.request(chatId, messageId))
    };
}

export default decorate(
    connect(injectPermissions(mapStateToProps), mapDispatchToProps),
    TraderChat
);
